var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 22.5C18.5 23.6046 17.6046 24.5 16.5 24.5H3.5C2.39543 24.5 1.5 23.6046 1.5 22.5V4H18.5V22.5ZM3 21C3 22.1046 3.89543 23 5 23H15C16.1046 23 17 22.1046 17 21V5H3V21Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 5H4.5V1.5C4.5 0.947715 4.94772 0.5 5.5 0.5H14.5C15.0523 0.5 15.5 0.947715 15.5 1.5V5ZM6 4H14V2H6V4Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 21C5.7235 21 5.5 20.7765 5.5 20.5V8C5.5 7.7235 5.7235 7.5 6 7.5C6.2765 7.5 6.5 7.7235 6.5 8V20.5C6.5 20.7765 6.2765 21 6 21Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 21C9.7235 21 9.5 20.7765 9.5 20.5V8C9.5 7.7235 9.7235 7.5 10 7.5C10.2765 7.5 10.5 7.7235 10.5 8V20.5C10.5 20.7765 10.2765 21 10 21Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21C13.7235 21 13.5 20.7765 13.5 20.5V8C13.5 7.7235 13.7235 7.5 14 7.5C14.2765 7.5 14.5 7.7235 14.5 8V20.5C14.5 20.7765 14.2765 21 14 21Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19 3.5H1C0.447715 3.5 0 3.94772 0 4.5C0 5.05228 0.447716 5.5 1 5.5H19C19.5523 5.5 20 5.05228 20 4.5C20 3.94772 19.5523 3.5 19 3.5Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.15b2c5613c35effd6baf460092cbbd7e.svg";
export { ForwardRef as ReactComponent };